import { createThemeService } from './ThemeService.impl';

/**
 * Global singleton instance of the ThemeService
 */
export const myThemeService = createThemeService();
